import "./SeoFreelancerDubai.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import Comparison from "./sections/Comparison";
import Explainer from "./sections/Explainer";
import ServicesGrid from "./sections/ServicesGrid";
import TargetAudience from "./sections/TargetAudience";
import Investments from "./sections/Investments";
import DubaiContext from "./sections/DubaiContext";
import DubaiStrategy from "./sections/DubaiStrategy";
import RegionalStrategy from "./sections/RegionalStrategy";
import InternationalDubai from "./sections/InternationalDubai";
import AiSearch from "./sections/AiSearch";
import Methodology from "./sections/Methodology";
import DirectPartnership from "./sections/DirectPartnership";
import DubaiFaq from "./sections/DubaiFaq";
import Conversion from "./sections/Conversion";
import Footer from "@/reusable_sections/Footer";
export default function SeoFreelancerDubaiPage() {
  return <div>
      <Header />
      <HeroBanner />
      <Comparison />
      <Explainer />
      <ServicesGrid />
      <TargetAudience />
      <Investments />
      <DubaiContext />
      <DubaiStrategy />
      <RegionalStrategy />
      <InternationalDubai />
      <AiSearch />
      <Methodology />
      <DirectPartnership />
      <DubaiFaq />
      <Conversion />
      <Footer />
    </div>;
}